import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Menu,
  MenuItem,
  makeStyles,
  TextField,
} from "@material-ui/core";
import React, { useRef, useState } from "react";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import useApi from "../hooks/useApi";
import { useGlobalSnackbar } from "../contexts/SnackbarContext";
import Loading from "../components/Loading";
import { useTranslation } from "react-i18next";
import {
  Done,
  Translate,
  KeyboardArrowUp,
  KeyboardArrowDown,
} from "@material-ui/icons";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles({
  content: {
    maxWidth: "100vw",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  card: {
    margin: "auto",
  },
  cardTitle: {
    textAlign: "left",
  },
  button: {
    width: "100%",
  },
  field: {
    marginBottom: ".5rem",
  },
  link: {
    textDecoration: "none",
  },
  languageButton: {
    textTransform: "none",
    margin: "0.5rem 0.5rem 0 auto",
  },
});

const Register = () => {
  const { t, i18n } = useTranslation(["views", "common"]);
  const classes = useStyles();
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [saPassword, setSaPassword] = useState("");
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [lastName, setLastName] = useState("");
  const [loading, setLoading] = useState(false);
  const setGlobalSnackbar = useGlobalSnackbar();
  const api = useApi();
  const [open, setOpen] = useState(false);
  const anchorEl = useRef();

  const languages = [
    { code: "en", label: "English" },
    { code: "es", label: "Español" },
    { code: "fr", label: "Français" },
    { code: "it", label: "Italiano" },
  ];
  const currentLanguage = (
    i18n.resolvedLanguage ||
    i18n.language ||
    "it"
  ).split("-")[0];

  const register = async (e) => {
    e.preventDefault();
    setLoading(true);
    const response = await api("register", "POST", {
      email,
      password,
      saPassword,
      code,
      name,
      lastName,
    });
    if (response.ok !== false) {
      setLoading(false);
      setGlobalSnackbar({
        open: true,
        severity: "success",
        message: `${t("common:success.account_created")}`,
      });
      history.push("/login");
      return;
    }
    const parsed = JSON.parse(response.message);
    setLoading(false);
    if (parsed.code == "duplicate_email")
      setGlobalSnackbar({
        open: true,
        severity: "error",
        message: (
          <>
            {t("common:errors.email_used")}
          </>
        ),
      });
    else if (parsed.code == "invalid_admin_password")
      setGlobalSnackbar({
        open: true,
        severity: "error",
        message: `${t("common:errors.invalid_password")}`,
      });
    else if (parsed.code == "invalid_clinic_code")
      setGlobalSnackbar({
        open: true,
        severity: "error",
        message: `${t("common:errors.invalid_code")}`,
      });
    else if (parsed.code == "validation_error")
      setGlobalSnackbar({
        open: true,
        severity: "error",
        message: `${t("common:errors.password")}`,
      });
    else
      setGlobalSnackbar({
        open: true,
        severity: "error",
        message: `${t("common:errors.invalid_registration")}`,
      });
  };
  return (
    <div className={classes.content}>
      <Loading loading={loading} />
      <Card className={classes.card}>
        <div style={{ display: "flex" }}>
          <Button
            className={classes.languageButton}
            aria-controls="language-menu"
            aria-haspopup="true"
            onClick={() => setOpen(true)}
            ref={anchorEl}
            endIcon={open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          >
            <Translate />
          </Button>
        </div>
        <Menu
          id="language-menu"
          anchorEl={anchorEl?.current}
          keepMounted
          open={open}
          getContentAnchorEl={null}
          onClose={() => setOpen(false)}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{ vertical: "top", horizontal: "center" }}
        >
          {languages.map((lang) => (
            <MenuItem
              key={lang.code}
              selected={lang.code === currentLanguage}
              onClick={() => {
                i18n.changeLanguage(lang.code);
                setOpen(false);
              }}
            >
              {currentLanguage == lang.code ? (
                <Done fontSize="small" />
              ) : (
                <span style={{ width: 24 }} />
              )}
              {lang.label}
            </MenuItem>
          ))}
        </Menu>
        <CardHeader
          title={t("views:register.title")}
          className={classes.cardTitle}
        />
        <CardContent>
          <form onSubmit={register}>
            <div className={classes.field}>
              <TextField
                name="email"
                type="email"
                id="Email"
                label={t("common:label.email")}
                required
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
            </div>
            <div className={classes.field}>
              <TextField
                name="name"
                id="name"
                label={t("common:label.name")}
                required
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
              />
            </div>
            <div className={classes.field}>
              <TextField
                name="lastName"
                id="lastName"
                label={t("common:label.last_name")}
                required
                value={lastName}
                onChange={(e) => {
                  setLastName(e.target.value);
                }}
              />
            </div>
            <div className={classes.field}>
              <TextField
                type="password"
                id="Password"
                label={t("common:label.account_password")}
                required
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              />
            </div>
            <div className={classes.field}>
              <TextField
                type="password"
                id="Password superadmin"
                label={t("common:label.superadmin_password")}
                required
                value={saPassword}
                onChange={(e) => {
                  setSaPassword(e.target.value);
                }}
              />
            </div>
            <div className={classes.field}>
              <TextField
                id="ClinicCode"
                label={t("common:label.clinic_code")}
                required
                value={code}
                onChange={(e) => {
                  setCode(e.target.value);
                }}
              />
            </div>
            <div>
              <Button
                type="submit"
                className={classes.button}
                variant="contained"
                color="primary"
                endIcon={<ArrowForwardIcon />}
              >
                {t("common:button.register")}
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default Register;
